<template>
    <div>
        <div class="feature-detail-page">


            <section class="feature-list mt-5">
                <div class="container">
                    <div v-for="(feature, index) in features" :key="index" class="feature-item"
                        :class="{ 'column-order-reverse': index % 2 !== 0 }">
                        <div class="row my-5">
                            <div class="col-lg-6 d-flex justify-content-center align-items-center feature-image-box">
                                <img :src="feature.image" :alt="feature.title" class="feature-image" />
                            </div>
                            <div class="col-lg-6 feature-text">
                                <h2>{{ feature.title }}</h2>
                                <p>{{ feature.description }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <appFooter />
    </div>
</template>

<script>
import pageHeader from "../components/pageHeader.vue";
import appFooter from "../layout/landing/appFooter.vue";

export default {
    components: {
        pageHeader,
        appFooter,
    },

    data() {
        return {
            features: [],
        };
    },

    metaInfo: {
        title: "Features | KIPS VIRTUAL",
        titleTemplate: "",
        htmlAttrs: {
            lang: "en",
            amp: true,
        },
    },

    mounted() {
        window.scrollTo(0, 0);
        this.features = this.getFeaturesData();
    },

    methods: {
        getFeaturesData() {
            return [
                {
                    title: "e-Lectures",
                    description:
                        "At KIPS Virtual, students can access live interactive lectures for real-time engagement with expert faculty and direct doubt resolution. For added flexibility, our recorded video lectures ensure students can learn at their own pace, revisit challenging topics, and enhance their understanding anytime, anywhere. Whether you prefer a structured class schedule or the convenience of on-demand learning, our e-lectures offer the best of both worlds.",
                    image: "/assets/images/e-lectures.png",
                },
                {
                    title: "Reading Material",
                    description:
                        "Complement your learning with KIPS Virtual's curated reading materials, carefully designed to provide in-depth explanations and insights into every subject. These resources, accessible online, are tailored to bridge the gap between theory and application, empowering students with a comprehensive understanding of their coursework.",
                    image: "/assets/images/reading-material.png",
                },
                {
                    title: "Quizzes",
                    description:
                        "KIPS Virtual provides a diverse range of tests to ensure comprehensive exam preparation. These tests encompass all question types, students may encounter, including MCQs, essay types (short & long questions), and full-length papers, effectively simulating the real exam environment. With three distinct testing formats—linear tests, offering a structured approach to assessing overall understanding; adaptive tests, which adjust difficulty based on student performance to challenge and improve; and paper-based tests, designed to replicate traditional exams for complete familiarity—students benefit from a holistic evaluation process. This variety equips students with the skills and confidence required to excel in their exams.",
                    image: "/assets/images/quizzes.png",
                },
                {
                    title: "AI Quizzes",
                    description:
                        "KIPS Virtual's AI Quizzes offer personalized, data-driven assessments to help students focus on areas requiring improvement. These quizzes are tailored for topic-wise enhancement, targeting specific areas where a student needs to strengthen their understanding, and question-wise rectification, revisiting questions previously answered incorrectly. By dynamically adapting to student performance, AI-generated quizzes ensure an efficient and effective preparation experience, helping students achieve academic mastery.",
                    image: "/assets/images/ai-quizzes.png",
                },
                {
                    title: "Assignments",
                    description:
                        "Regular assignments are an integral part of the KIPS Virtual Learning Experience. Tailored to reinforce key concepts, these assignments challenge students to apply their knowledge and develop critical thinking skills. Submitted online and reviewed by our experienced faculty, assignments provide personalized feedback to help students continuously improve.",
                    image: "/assets/images/assignments.png",
                },
                {
                    title: "Live Sessions",
                    description:
                        "KIPS Virtual offers live sessions designed to clarify doubts and deepen understanding. These sessions include interactive lectures, where students can engage directly with their teachers, and dedicated doubt-clearing sessions, ensuring every question is answered and every concept mastered.",
                    image: "/assets/images/live-sessions.png",
                },
                {
                    title: "Teacher Support",
                    description:
                        "With KIPS Virtual, students are never alone in their learning journey. Our teacher support system provides instant access to subject experts via chat or live interactions, enabling students to get answers to their queries, resolve challenges, and stay motivated.",
                    image: "/assets/images/teacher-support.png",
                },
                {
                    title: "KAIA",
                    description:
                        "Meet KAIA, your personal AI tutor at KIPS Virtual. Powered by advanced AI technology, KAIA offers personalized guidance, adapts to your learning needs, and provides instant support for quizzes, assignments, and study schedules. KAIA ensures your preparation is efficient and targeted, making learning smarter and more effective.",
                    image: "/assets/images/kaia.png",
                },
                {
                    title: "Notes",
                    description:
                        "Stay organized and optimize your learning with KIPS Virtual's notes feature. Jot down important points while watching videos (complete with timestamps for easy reference) or reading materials. Bookmark essential topics and lectures to review them later with ease, ensuring nothing important slips through the cracks.",
                    image: "/assets/images/notes.png",
                },
                {
                    title: "Content Search",
                    description:
                        "Quickly locate the information you need with our content search tool. Whether you're looking for a specific video, reading, or quiz, the intuitive search function saves time and helps you stay focused on your studies.",
                    image: "/assets/images/content-search.png",
                },
                {
                    title: "Program Stats",
                    description:
                        "Track your progress with program stats, which provide a detailed overview of your course completion, test results, and performance in each subject. These insights help you identify strengths and areas for improvement, keeping you on the path to success.",
                    image: "/assets/images/program-stats.png",
                },
                {
                    title: "Leaderboard",
                    description:
                        "Compete with peers and stay motivated with KIPS Virtual's leaderboard. View your rank among students in your program and challenge yourself to climb higher while celebrating your achievements.",
                    image: "/assets/images/leaderboard.png",
                },
                {
                    title: "eBooks",
                    description:
                        "Access a vast library of ebooks tailored to your syllabus, offering detailed explanations, examples, and practice questions. These digital resources are available anytime, providing a convenient and cost-effective way to deepen your understanding and prepare comprehensively for exams.",
                    image: "/assets/images/ebooks.png",
                },
            ];
        },
    },
};
</script>

<style lang="scss" scoped>
.feature-detail-page {
    .page-header-section {
        position: relative;
        padding: 100px 0 150px;
        background: #eef3f6;
        overflow: hidden;

        .circle-pattern-3 {
            position: absolute;
            top: -60px;
            right: -60px;
            width: 200px;
            height: 200px;
            opacity: 0.3;
            animation: rotate 10s linear infinite;
        }

        .heading {
            font-size: 3rem;
            font-weight: bold;
            color: #333;
        }

        .desc {
            font-size: 1.2rem;
            color: #555;
        }
    }

    .feature-list {
        padding: 80px 0;

        .feature-item {
            margin-bottom: 80px;
            display: flex;
            align-items: center;

            &:last-child {
                margin-bottom: 0;
            }

            .feature-image {
                width: 100%;
                height: auto;
                border-radius: 8px;
                box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
            }

            .feature-text {
                padding: 0 30px;
                text-align: left;
                /* Ensure left alignment */
                display: flex;
                flex-direction: column;
                justify-content: center;
                /* Vertically center */

                h2 {
                    font-size: 26px;
                    font-weight: 600;
                    font-family: "Poppins", sans-serif;
                    margin-bottom: 20px;
                    color: #333;
                    line-height: 100%;
                    text-align: left;
                }

                p {
                    font-size: 16px;
                    line-height: 26px;
                    font-weight: 400;
                    font-family: "Poppins", sans-serif;
                    color: #666;
                }
            }

            &.column-order-reverse {
                .row {
                    flex-direction: row-reverse;
                }
            }
        }
    }
    @media screen and (max-width: 991px) {

        .feature-list {
            padding: 40px 0;
        }
        .feature-image-box{
            margin-bottom: 30px;
        }
        .feature-list .feature-item{
            margin-bottom: 0;
        }
        .feature-item .row{
            margin-top:0 !important;
            margin-bottom:0 !important;
        }

    }
}

@keyframes rotate {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>
